import { collection, deleteDoc, doc, getDoc, getDocs, getFirestore, orderBy, query, serverTimestamp, setDoc, Timestamp, where, writeBatch } from 'firebase/firestore'
import { IFrozenInventoryItem, IInventoryItem, IInventoryItemAuthor, IInventoryMeta } from '../../shared/types'

type InventoryItem= IInventoryItem | IFrozenInventoryItem

const addProduct = async (product:Partial<InventoryItem>, business_id:string, shop_id:string, author:IInventoryItemAuthor)=>{

    try {

        const ref = doc(getFirestore(), "businesses", business_id, "shops", shop_id, "inventory", product.name!)
        const newInventoryItem:InventoryItem = {
            ...product as InventoryItem,
            created_at: serverTimestamp(),
            meta_data: {
                business_id,
                shop_id,
                author
            }
        }

        await setDoc(ref, newInventoryItem)

        return {
            ...product,
            created_at: new Date().toDateString()
        }

        
    } catch (error) {
        throw error
    }
    
}

const addProductsBulk = async (productsArray: Partial<IInventoryItem>[], business_id:string, shop_id:string, author:IInventoryItemAuthor)=>{

    try {

        const batch = writeBatch(getFirestore())
        
        productsArray.forEach((product)=>{

            const productRef = doc(getFirestore(), "businesses", business_id, "shops", shop_id, "inventory", product.name!)
            const newInventoryItem:IInventoryItem = {
                ...product as IInventoryItem,
                created_at: serverTimestamp(),
                meta_data: {
                    business_id,
                    shop_id,
                    author
                }
            }
            
            batch.set(productRef, newInventoryItem)
            
        })

        await batch.commit()
        return
        
    } catch (error) {
        throw error
    }
    
}


const deleteProduct = async (product_name:string, business_id:string, shop_id:string)=>{

    try {

        const ref = doc(getFirestore(), "businesses", business_id, "shops", shop_id, "inventory", product_name)
        await deleteDoc(ref)
        
    } catch (error) {
        throw error
    }

}


const deleteProductBulk = async (productnames: string[], business_id:string, shop_id:string)=>{

    try {

        const batch = writeBatch(getFirestore())
        
        productnames.forEach((product_name)=>{

            const ref = doc(getFirestore(), "businesses", business_id, "shops", shop_id, "inventory", product_name!)
            batch.delete(ref)

        })

        await batch.commit()

        
    } catch (error) {
        throw error
    }
    
}

const getMetaData = async (business_id:string, shop_id:string)=>{

    try {

        const ref = doc(getFirestore(), "businesses", business_id, "shops", shop_id, "meta_data", "inventory")
        const res = await getDoc(ref)

        if(res.exists()){
            return res.data() as IInventoryMeta
        }else{
            return{
                inventory_size: 0,
                expected_revenue: 0,
                expected_profit: 0,
                damaged: 0,
                expired: 0
            } as IInventoryMeta
        }
        
    } catch (error) {
        throw error
    }
    
}


const getProducts = async (business_id:string, shop_id:string)=>{

    try {

        const products:IInventoryItem[] = []
        const ref = collection(getFirestore(), "businesses", business_id,"shops", shop_id, "inventory")

        const q = query(ref, orderBy("name", "asc"))

        const res = await getDocs(q)

        res.forEach((product)=>{

            if(product.exists()){

                const timeStamp = new Timestamp(product.data().created_at.seconds, product.data().created_at.nanoseconds).toMillis()
                
                const newProduct:IInventoryItem = {
                    ...product.data() as IInventoryItem,
                    created_at: new Date(timeStamp)
                }

                products.push(newProduct)

            }
            
        })

        return products
        
    } catch (error) {
        throw error
    }
    
}

const getProductsByDateRange = async (start_date:Date, end_date:Date, business_id:string, shop_id:string)=>{

    try {

        const products:any[] = []

        const products_ref = collection(getFirestore(), "businesses", business_id, "shops",shop_id, "inventory")
        const q = query(products_ref, where("created_at", ">=", start_date), where("created_at", "<=", end_date))

        const res = await getDocs(q)

        res.forEach((product)=>{

            if(product.exists()){

                const timeStamp = new Timestamp(product.data().created_at.seconds, product.data().created_at.nanoseconds).toMillis()
                
                const newProduct = {
                    ...product.data(),
                    created_at: new Date(timeStamp)
                }

                products.push(newProduct)

            }
            
        })

        return products
        
    } catch (error) {
        throw error
    }
    
}



const Inventory = {
    addProduct,
    addProductsBulk,
    deleteProduct,
    deleteProductBulk,
    getMetaData,
    getProducts,
    getProductsByDateRange

}

export default Inventory